import { createFileRoute } from '@tanstack/react-router';
import { RunsTab } from '@/pages/workspaces/integrations/sql-sync/import/tabs/runs-tab';
import { withRumPageRendered } from '@/services/rum/use-page-rendered';

/** The Imports tab: the import's run history, with its configuration beside it. */
export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/integrations/sql-sync/$type/$sqlImportId/',
)({
  component: withRumPageRendered(RunsTab),
});
